<template>
  <div class="col-xl-3 order-xl-1 col-lg-3 order-lg-1 col-md-12 order-md-2 col-sm-12 col-xs-12 responsive-display-none">
    <div class="ui-block">
      <div class="your-profile">
        <div class="ui-block-title ui-block-title-small">
          <h6 class="title">
            TAGS
          </h6>
        </div>

        <div
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="card">
            <div
              id="headingOne"
              class="card-header"
              role="tab"
            >
              <h6
                class="mb-0"
                @click="getAllExercises"
              >
                All Tags
              </h6>
            </div>

            <div
              id="collapseOne"
              class="collapse show"
              role="tabpanel"
              aria-labelledby="headingOne"
            >
              <ul class="your-profile-menu">
                <li
                  v-for="item in tags"
                  :key="item.id"
                >
                  <a @click="filterByTag(item.id)">{{ item.title }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- ... end Your Profile  -->
    </div>
  </div>
</template>

<script>

import VModal from 'vue-js-modal';
import Vue from 'vue'
// import '../../../node_modules/vue-wysiwyg/dist/vueWysiwyg.css'
Vue.use(VModal, {dialog: true});



export default {
  name: 'ExerciseTags',
  props: {
    tags: {
      type: Array,
      default: function () { return [] }
    },
    catid: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      perpage: 10
    }
  },
  methods: {
    filterByTag (tagId) {
      this.$store.dispatch('exercise/getExercisesByTag', tagId)
    },
    getAllExercises () {
      this.$store.dispatch('exercise/getExercises', { currentPage: 1, perpage: this.perpage, catid: this.catid, fromSidebar: 1 })
    }
  }
}
</script>
